import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'gcv-confirm-dialog',
  templateUrl: './confirmDialog.component.html',
  styleUrls: ['./confirmDialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  message = '';
  title = 'Confirm';
  showWarningLogo = false;
  firstButton = { text: 'Cancel', type: 'tertiary', display: true };
  secondButton = { text: 'Confirm', type: 'danger', display: true };
  html;
  image;

  constructor(private matDialogRef: MatDialogRef<ConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.message = data.message;
    this.title = data.title ? data.title : 'Confirm';
    if (data.firstButton) {
      this.firstButton = { ...this.firstButton, ...data.firstButton };
      this.secondButton = { ...this.secondButton, ...data.secondButton };
    }
    if (data.html) {
      this.html = data.html;
    }
    if (data.image) {
      this.image = data.image;
    }

    if (data.showWarningLogo) {
      this.showWarningLogo = data.showWarningLogo;
    }
  }

  approve() {
    this.close(true);
  }

  close(val: boolean = false) {
    this.matDialogRef.close({ confirmed: val });
  }
}
